import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'material-ui/FontIcon';
import { connect } from 'react-redux';
import { setValue } from 'redux/modules/customAudiences';
import * as styles from './CustomAudienceBuilder.scss';
var CABEntrySection = (_dec = connect(function (state) {
  return {
    theme: state.theme,
    organization: state.organization.current
  };
}, {
  setValue: setValue
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(CABEntrySection, _Component);

  var _super = _createSuper(CABEntrySection);

  function CABEntrySection(props) {
    var _this;

    _classCallCheck(this, CABEntrySection);

    _this = _super.call(this, props);
    _this.state = {
      audienceTypeOptions: [{
        name: 'Website Traffic',
        value: 'pixel',
        description: 'Create a list of people who visited your website using a Facebook Pixel.',
        icon: function icon() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return /*#__PURE__*/React.createElement(FontIcon, _extends({
            className: "fa fa-globe"
          }, props));
        }
      }, {
        name: 'Customer File',
        value: 'file',
        description: 'Use a customer file to match your customers and prospects with people on Facebook and create an audience from the matches.',
        icon: function icon() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return /*#__PURE__*/React.createElement(FontIcon, _extends({
            className: "fa fa-user"
          }, props));
        }
      }]
    };
    return _this;
  }

  _createClass(CABEntrySection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-around'
        }
      }, this.state.audienceTypeOptions.map(function (_ref, index) {
        var name = _ref.name,
            value = _ref.value,
            description = _ref.description,
            Icon = _ref.icon;
        return /*#__PURE__*/React.createElement("div", {
          key: "entryWrap_".concat(index),
          className: styles.entryWrapper,
          onClick: function onClick() {
            _this2.props.setValue('audienceType', value);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          style: {
            fontSize: 48
          }
        }), /*#__PURE__*/React.createElement("h3", null, name), /*#__PURE__*/React.createElement("p", null, description));
      }));
    }
  }]);

  return CABEntrySection;
}(Component)) || _class);
export { CABEntrySection as default };